var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.71 1.36694L30.6585 61.16L41.8349 41.8351L30.5012 0L29.71 1.36694Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5015 0L30.6156 19.3249H41.8352L30.5015 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3247 19.3249H30.6153L30.5012 0L19.3247 19.3249Z",
    fill: "#B5B5B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8351 19.3252L0 30.5879L1.40499 31.4121L60.7289 30.8364L61.1575 30.5803L41.8351 19.3252Z",
    fill: "#B5B5B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3247 41.835L30.6584 61.1599L30.6102 41.835H19.3247Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3249 19.3252L0 30.5879H19.3249V19.3252Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.5877L19.3249 41.9163V30.5801L0 30.5877Z",
    fill: "#B5B5B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4746 19.3252L30.6156 30.4662L41.754 19.3252H19.4746Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6152 30.4662L41.8348 41.6858V19.3252H41.7537L30.6152 30.4662Z",
    fill: "#131313"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4743 19.3252H19.3247V41.7542L30.6153 30.4662L19.4743 19.3252Z",
    fill: "#131313"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3247 41.7539V41.8351H41.8349V41.6854L30.6153 30.4658L19.3247 41.7539Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.835 30.5801V41.9163L61.1599 30.5826L61.1573 30.5801H41.835Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5787 14.663L14.6616 30.5801L30.5787 46.4972L46.4959 30.5801L30.5787 14.663Z",
    fill: "#EAE6D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1492 8.90137L50.9218 9.22852L9.35042 50.739L8.9624 52.2099L46.4963 30.5797L52.1492 8.90137Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5801 14.6633L38.3937 22.477L52.1494 8.90137L30.5801 14.6633Z",
    fill: "#9D9D9D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5966 38.4824L30.5801 46.4964L52.261 52.1493L52.2585 52.1443L38.5966 38.4824Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4963 30.5794L8.94971 8.96191L9.66234 10.8792L50.1685 51.6035L52.2583 52.1437L46.4963 30.5794Z",
    fill: "#9D9D9D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6635 30.5801L8.9624 52.2103L22.4771 38.3937L14.6635 30.5801Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4771 38.3936L8.9624 52.2101L30.5799 46.4963L22.4771 38.3936Z",
    fill: "#9D9D9D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5799 14.663L8.94971 8.96191L22.68 22.5654L30.5799 14.663Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94971 8.96191L14.6635 30.5794L22.68 22.5654L8.94971 8.96191Z",
    fill: "#9D9D9D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5801 14.6631L30.6866 30.5237L46.4965 30.5795L30.5801 14.6631Z",
    fill: "#DEDEDE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6866 30.5244L30.5801 46.4966L46.4965 30.5802L30.6866 30.5244Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.58 14.6631L14.6636 30.5795L30.6865 30.5237L30.58 14.6631Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6636 30.5802L30.58 46.4966L30.6865 30.5244L14.6636 30.5802Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c18f46c3f219c485a33e2e802141d3d4.svg";
export { ForwardRef as ReactComponent };